const createAction = name => ({
    UPDATE: `${name}_UPDATE`,
    CHANGE: `${name}_CHANGE`
});

export const LANGUAGE = createAction('LANGUAGE');

export const updateWording = () => async (dispatch, getState) => {
    const { currentLanguage } = getState().language;
    dispatch({
        type: LANGUAGE.UPDATE,
        payload: currentLanguage
    });
};

export const LanguageChange = value => (dispatch, getState) => {
    dispatch({
        type: LANGUAGE.CHANGE,
        payload: value
    })
};
